(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bind = root => {
    root.querySelectorAll('.marame-campaign__categories').forEach(detail => {
      if (detail.dataset.figmaBound) return;
      detail.dataset.figmaBound = 'true';
      detail.addEventListener('toggle', () => {
        if (detail.open) detail.closest('.marame-campaign')?.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
      });
      detail.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !detail.open) return;
        event.preventDefault(); detail.open = false; detail.querySelector('summary')?.focus();
      });
    });
    if (!('IntersectionObserver' in window) || reducedMotion.matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); } });
    }, { threshold:.15 });
    root.querySelectorAll('[data-marame-reveal]').forEach(element => observer.observe(element));
  };
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
